import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, FormControl, FormControlLabel, FormHelperText, Link, useTheme } from "@mui/material";
import { ModalContent, useModal } from "../../Shared/components/Modal";
import Stack from "@mui/material/Stack";
import { TermsAndConditionsText } from "./TermsAndConditions-types";
import Typography from "@mui/material/Typography";
import { MuiMarkdown_V2 } from "../../Shared/components/MuiMarkdown/MuiMarkdown_V2";
//If only title is defined OR both title and text are defined, the title will display
//Otherwise, default title will display with link that opens a modal where text will display
const TextDisplay = ({ showTitle, showTitleAndText, title, text }) => {
    const theme = useTheme();
    const { showModal } = useModal();
    return showTitle || showTitleAndText ? (_jsx(MuiMarkdown_V2, Object.assign({ style: { marginBottom: 0 } }, { children: title }))) : (_jsxs(Typography, { children: [TermsAndConditionsText.DEFAULT_TEXT, _jsx(Link, Object.assign({ sx: { paddingLeft: theme.spacing(0.5) }, variant: "inherit", underline: "always", onClick: (e) => {
                    //Stops checkbox from changing state when clicking link
                    e.preventDefault();
                    showModal({
                        title: TermsAndConditionsText.TERMS_AND_CONDITIONS,
                        content: (_jsx(ModalContent, { children: _jsx(MuiMarkdown_V2, { children: text }) })),
                    });
                } }, { children: TermsAndConditionsText.TERMS_AND_CONDITIONS }))] }));
};
/**
 * Displays a checkbox with title and text. Optionally displays link that opens a modal to display text
 * @param title
 * @param text
 * @param field
 * @param error
 * @returns
 */
export const TermsAndConditions = ({ text, title, field, error }) => {
    const theme = useTheme();
    const showTitle = Boolean(title && !text);
    const showTitleAndText = Boolean(title && text);
    return (_jsxs(Stack, { children: [_jsxs(FormControl, { children: [_jsx(FormControlLabel, { name: "terms", control: _jsx(Checkbox, Object.assign({}, field, { inputRef: field.ref, checked: field.value, name: "terms", color: "primary", size: "small" })), label: _jsx(TextDisplay, Object.assign({}, { showTitle, showTitleAndText, title, text })), labelPlacement: "end" }), error && (_jsx(FormHelperText, Object.assign({ style: { marginBottom: theme.spacing(1), color: theme.palette.error.main } }, { children: Boolean(error) && (error === null || error === void 0 ? void 0 : error.message) })))] }), showTitleAndText && _jsx(MuiMarkdown_V2, { children: text })] }));
};
